<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
    <div class="col-12">
      <div class="bg-white q-mx-md-md">
        <div style="text-align: center; padding-top: 40px; padding-bottom: 40px">
          <img src="/assets/images/group2.svg" />
        </div>
        <div class="q-px-lg q-py-lg">
          <MainHeadline
            align="center"
            header="Congratulations, your application has been approved."
            body="The lease documentation is being prepared and will be issued via DocuSign for completion."
          />
        </div>
        <div v-if="1 === 0" class="q-px-lg q-py-lg" style="text-align: center">
          <QBtn color="primary" no-caps @click="onClickHandler()">{{ isWetSignature ? 'Review & Sign Contract' : 'Sign Lease' }}</QBtn>
        </div>
        <MoreInfoBlock />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapState, mapGetters } from 'vuex';
import MainHeadline from '@/components/Atoms/MainHeadline';
import MoreInfoBlock from '@/components/Atoms/MoreInfoBlock';

export default {
  name: 'CalculatorAccepted',
  components: { QBtn, MainHeadline, MoreInfoBlock },
  props: [],
  computed: {
    ...mapGetters({ isWetSignature: 'vehicleApplication/isWetSignature' })
  },
  created() {},
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    onClickHandler: function () {
      this.loading = true;
      setTimeout(() => {
        this.$emit('onSignContract');
      });
      this.loading = false;
    }
  }
};
</script>
